export enum GameEvent {
  LAUNCH_REAL_GAME = 'LaunchRealGameEvent',
  LAUNCH_DEMO_GAME = 'LaunchDemoGameEvent',
  RESTORE_GAME = 'RestoreGame',
  RESTORE_SESSION = 'RestoreSession',
  FAVOURITE_GAME_ADD = 'FavouriteGameAddEvent',
  FAVOURITE_GAME_REMOVE = 'FavouriteGameRemoveEvent',
  LIKE_GAME = 'LikeGameEvent',
  DISLIKE_GAME = 'DislikeGameEvent',
  SOCIAL_SHARE = 'SocialShareEvent',
  TOGGLE_IN_GAME_CATEGORY = 'ToggleInGameCategoryEvent',
  TOGGLE_IN_GAME_CATEGORY_MENU = 'ToggleInGameCategoryMenuEvent',
  TOGGLE_IN_GAME_HAMBURGER_MENU = 'ToggleInGameHamburgerMenuEvent',
  EXIT_DRAWER_DO_NOT_SHOW_AGAIN = 'ExitDrawerDoNotShowAgainEvent',
  EXIT_DRAWER_CONTINUE_PLAYING = 'ExitDrawerContinuePlayingEvent',
  EXIT_DRAWER_EXIT_GAME = 'ExitDrawerExitGameEvent',
  EXIT_DRAWER_OPEN_GAME = 'ExitDrawerOpenGameEvent',
}
